<template>
  <!-- ホーム画面 -->
  <div id="philipsHome">
    <template v-if="roleId == role.role_admin || roleId == role.role_headOffice || roleId == role.role_salesOffice">
      <div class="heading-title" style="display:flex; justify-content: space-between; align-items: center;">
        <div style="display:flex;">ワンクリックオーダー<div class="shippingdate-header-notice">※日付は最短出荷日です</div></div>
        <div style="display:flex; align-items:flex-end; gap: 15px;">
          <div class="update-date">
            更新日時：
            <template v-if="oneClickOrderUpdateDate == ''">未取得</template>
            <template v-else>{{oneClickOrderUpdateDate}}</template>
          </div>
          <b-button icon-left="refresh" class="update-button" :disabled="oneClickOrderUpdateButtonDisabled" @click="getOneClickOrderList">{{oneClickOrderUpdateButtonLabel}}</b-button>
        </div>
      </div>
      <div v-if="listOfShippingDate.length > 0">
        <div class="shippingdate-container">
          <template v-for="(medicalTestModel,index) in listOfShippingDate">
            <button
              :key="index"
              class="shippingdate-button"
              :class="shippingButtonColor(medicalTestModel.kind)"
              type="button"
              @click="goToOneClickOrder(medicalTestModel.kind)"
            >
              <div class="shippingdate-button-label">
                <div class="model-kind">{{medicalTestModel.kind}}</div>
                <div class="model-title" v-html="medicalTestModel.modelName.replace(' ', '<br>')"></div>
                <div class="shippingdate">{{medicalTestModel.shippingDate}}</div>
              </div>
            </button>
          </template>
          <button
            v-if="roleId == role.role_admin || roleId == role.role_salesOffice"
            class="shippingdate-button holter"
            type="button"
            @click="goToOneClickOrder('ホルター院内貸出', '')"
          >
            <div class="shippingdate-button-label">
              <div class="model-kind">ホルター心電図</div>
              <div class="model-title">ePatch 院内貸出</div>
            </div>
          </button>
          <button
            class="shippingdate-button cpap"
            type="button"
            @click="goToOneClickOrder('CPAP', '')"
          >
            <div class="shippingdate-button-label">
              <div class="model-kind">CPAP</div>
              <div class="model-title">新規処方申込み</div>
            </div>
          </button>
          <button
            class="shippingdate-button cpap"
            type="button"
            @click="goToOneClickOrder('CPAP預託', '')"
          >
            <div class="shippingdate-button-label">
              <div class="model-kind">CPAP 預託</div>
              <div class="model-title">新規処方申込み</div>
            </div>
          </button>
        </div>
      </div>
    </template>
    <template v-if="roleId == role.role_admin || roleId == role.role_salesOffice">
      <div class="heading-title" style="display:flex; justify-content: space-between; align-items: center; font-size:24px;">
        <div style="display:flex;">マイタスク<div v-if="taskUpdateDate != '' && listOfKensaTaskData.length <= 0 && listOfCpapTaskData.length <= 0">【 0件 】</div></div>
        <div style="display:flex; align-items:flex-end; gap: 15px;">
          <div class="update-date" style="display:flex">
            更新日時：
            <template v-if="taskUpdateDate == ''">未取得</template>
            <template v-else>{{taskUpdateDate}}</template>
          </div>
          <b-button icon-left="refresh" class="update-button" :disabled="taskUpdateButtonDisabled"  @click="getTaskList">{{taskUpdateButtonLabel}}</b-button>
        </div>
      </div>
      <div class="flex-container">
        <div v-if="roleId == role.role_salesOffice && listOfKensaTaskData.length > 0" class="flex-item">
          <b-table :data="listOfKensaTaskData" class="kensaTask-table">
            <template slot-scope="props">
              <b-table-column field="content" label="タスク内容">
                {{ props.row.content }}
              </b-table-column>
              <b-table-column field="hstCount" label="睡眠検査">
                <router-link :to="{name: props.row.hstUserRouterName, params:{taskSearchConditions: props.row.hstUserRouterParams}}"><a style="text-decoration: underline;">{{ props.row.hstCount }}件</a></router-link>
              </b-table-column>
              <b-table-column field="holterCount" label="ホルター">
                <template v-if="props.row.holterUserRouterName">
                  <router-link :to="{name: props.row.holterUserRouterName, params:{taskSearchConditions: props.row.holterUserRouterParams}}">
                    <a style="text-decoration: underline;">{{ props.row.holterCount }}件</a>
                  </router-link>
                </template>
                <template v-else>
                  {{ props.row.holterCount }}件
                </template>
              </b-table-column>
              <b-table-column field="totalCount" label="合計">
                <router-link :to="{name: props.row.totalUserRouterName, params:{taskSearchConditions: props.row.totalUserRouterParams}}"><a style="text-decoration: underline;">{{ props.row.totalCount }}件</a></router-link>
              </b-table-column>
            </template>
          </b-table>
        </div>
        <div v-if="roleId == role.role_salesOffice && listOfCpapTaskData.length > 0" class="flex-item">
          <b-table :data="listOfCpapTaskData" class="otherTask-table" @click="goTask">
            <template slot-scope="props">
              <b-table-column field="category" label="カテゴリ">
                {{ props.row.category }}
              </b-table-column>
              <b-table-column field="content" label="タスク内容">
                {{ props.row.content }}
              </b-table-column>
              <b-table-column field="count" label="件数">
                {{ props.row.count }}件
              </b-table-column>
            </template>
          </b-table>
        </div>
      </div>
    </template>
    <div class="heading-title" style="display:flex; justify-content: space-between; align-items: center;">情報ポータル</div>
    <div class="flex-container">
      <div class="flex-item" v-if="listOfNoticeData.length > 0">
        <div class="content-title">お知らせ</div>
        <div class="a-left">
          <a class="view-all" @click="goToArticleList(1)">すべて見る </a>
        </div>
        <b-table :data="filterdListOfNoticeData" class="notice-table">
          <template slot-scope="props">
            <b-table-column field="title" label="タイトル">
              <a
                @click="
                  showModal(
                    props.row.title,
                    props.row.content,
                    props.row.createdAt
                  )
                "
                >{{ props.row.title }}</a
              >
            </b-table-column>
            <b-table-column field="content" label="本文">
              {{ props.row.content }}
            </b-table-column>
          </template>
        </b-table>
      </div>
      <div class="flex-item" v-if="listOfGuidanceData.length > 0">
        <div class="content-title">ご案内</div>
        <div class="a-left">
          <a class="view-all" @click="goToArticleList(2)"> すべて見る </a>
        </div>
        <b-table :data="filterdListOfGuidanceData" class="guidance-table">
          <template slot-scope="props">
            <b-table-column field="title" label="タイトル">
              <a @click="downloadFile(props.row.pdfFileUrl)">{{
                props.row.title
              }}</a>
            </b-table-column>
            <b-table-column field="product_code" label="製品名">
              {{ props.row.productNames }}
            </b-table-column>
            <b-table-column label="PDF閲覧" centered>
              <a @click="downloadFile(props.row.pdfFileUrl)"
                ><b-icon icon="clipboard-arrow-right-outline"
              /></a>
            </b-table-column>
          </template>
        </b-table>
      </div>
      <div class="flex-item" v-if="listOfEventData.length > 0">
        <div class="content-title">学会・イベント情報</div>
        <div class="a-left">
          <a class="view-all" @click="goToArticleList(3)"> すべて見る </a>
        </div>
        <div class="event-news-container">
          <div class="event-news-item1">
            <a @click="downloadFile(listOfEventData[0].pdfFileUrl)"
              ><img
                v-if="
                  listOfEventData.length > 0 && listOfEventData[0].imageFileUrl
                "
                :src="listOfEventData[0].imageFileUrl"
                class="event-news-hero-img" />
              <img
                v-else
                src="@/assets/image-off-outline.svg"
                class="event-news-hero-img"
            /></a>
            <div>
              {{ listOfEventData.length > 0 ? listOfEventData[0].title : "" }}
            </div>
          </div>
          <div class="event-news-item2-4">
            <b-table :data="filterdListOfEventData" class="event-table">
              <template slot-scope="props">
                <b-table-column field="title" label="タイトル">
                  <a @click="downloadFile(props.row.pdfFileUrl)">{{
                    props.row.title
                  }}</a>
                </b-table-column>
                <b-table-column field="pdfUrl" label="PDF閲覧" centered>
                  <a @click="downloadFile(props.row.pdfFileUrl)"
                    ><b-icon icon="clipboard-arrow-right-outline"
                  /></a>
                </b-table-column>
                <b-table-column filed="externalUrl" label="関連サイト" centered>
                  <a
                    v-if="props.row.externalLinkUrl"
                    @click="goToExternalLinkUrl(props.row.externalLinkUrl)"
                    class="infoicon"
                    ><b-icon icon="earth-arrow-right"
                  /></a>
                </b-table-column>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="flex-item" v-if="listOfNewsData.length > 0">
        <div class="content-title">ニュース</div>
        <div class="a-left">
          <a class="view-all" @click="goToArticleList(4)"> すべて見る </a>
        </div>
        <div class="event-news-container">
          <div class="event-news-item1">
            <a @click="goToTitleLinkUrl(listOfNewsData[0].titleLinkUrl)"
              ><img
                v-if="
                  listOfNewsData.length > 0 && listOfNewsData[0].imageFileUrl
                "
                :src="listOfNewsData[0].imageFileUrl"
                class="event-news-hero-img" />
              <img
                v-else
                src="@/assets/image-off-outline.svg"
                class="event-news-hero-img"
            /></a>
            <div>
              {{ listOfNewsData.length > 0 ? listOfNewsData[0].title : "" }}
            </div>
          </div>
          <div class="event-news-item2-4">
            <b-table :data="filterdListOfNewsData" class="news-table">
              <template slot-scope="props">
                <b-table-column field="title" label="タイトル">
                  <a @click="goToTitleLinkUrl(props.row.titleLinkUrl)">{{
                    props.row.title
                  }}</a>
                </b-table-column>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="flex-item" v-if="listOfProductData.length > 0">
        <div class="content-title">製品情報</div>
        <div class="a-left">
          <a class="view-all" @click="goToArticleList(5)"> すべて見る </a>
        </div>
        <b-table :data="filterdListOfProductData" class="product-table">
          <template slot-scope="props">
            <b-table-column field="title" label="タイトル">
              <a
                v-if="props.row.pdfFileUrl"
                @click="downloadFile(props.row.pdfFileUrl)"
                >{{ props.row.title }}</a
              >
              <a
                v-else-if="props.row.externalLinkUrl"
                @click="goToExternalLinkUrl(props.row.externalLinkUrl)"
                >{{ props.row.title }}</a
              >
            </b-table-column>
            <b-table-column field="product_code" label="製品名">
              {{ props.row.productNames }}
            </b-table-column>
            <b-table-column field="target_audience_code" label="対象者">
              {{ props.row.targetAudienceName }}
            </b-table-column>
            <b-table-column label="PDF閲覧" centered>
              <a
                @click="downloadFile(props.row.pdfFileUrl)"
                v-show="props.row.pdfFileUrl"
                ><b-icon icon="clipboard-arrow-right-outline"
              /></a>
            </b-table-column>
            <b-table-column label="関連サイト" centered>
              <a
                v-if="props.row.externalLinkUrl"
                @click="goToExternalLinkUrl(props.row.externalLinkUrl)"
                class="infoicon"
                ><b-icon icon="play-box-multiple"
              /></a>
            </b-table-column>
          </template>
        </b-table>
      </div>
      <div class="flex-item">
        <div class="content-title" style="height: auto">
          <div>無呼吸ラボはこちらから</div>
          <div class="lab-img">
            <a
              href="https://mukokyu-lab.jp/"
              target="_blank"
              rel="noopener noreferrer"
              ><img
                src="@/assets/images/apnea-lab-banner-image.jpeg"
                style="height: 180px"
            /></a>
          </div>
        </div>
      </div>
      <div class="terms-of-use-area">
        <div class="terms-of-use">
          <a
            href="https://www.philips.co.jp/a-w/terms-of-use"
            style="color: blue"
            >ご利用条件</a
          >
        </div>
        <div class="caveat">
          <span
            >本サイトの利用者は、利用条件を承認したとみなされますので、利用条件をご確認ください。</span
          >
        </div>
      </div>
    </div>
    <b-modal
      :active.sync="caveatPasswordChange"
      @close="closeModal"
      has-modal-card
    >
      <caveatPasswordChange-modal></caveatPasswordChange-modal>
    </b-modal>
    <b-modal
      :active.sync="noticeModalActive"
      :width="640"
      :height="640"
      scroll="keep"
    >
      <div class="modal-notice">
        <div class="content">
          <div class="modal-headline">【お知らせ】</div>
          <div class="modal-title">「{{ modalTitle }}」</div>
          <div class="modal-content">{{ modalContent }}</div>
          <div class="modal-createdAt">{{ modalCreatedAt }}</div>
          <b-button class="is-primary" @click="noticeModalActive = false"
            >閉じる</b-button
          >
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { role, extUserStatus } from "@/components/mock/base/const.js";
import header from "../base/header.vue";
const UPDATE_BUTTON_LABEL = {
  DEFAULT: "更新",
  LOADING: "更新中",
};

const caveatPasswordChangeForm = {
  props: [],
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var passwordLimit = userInfo.passwordLimit;
    return {
      userInfo,
      passwordLimit,
    };
  },
  methods: {
    inputAnswerYes: function (event) {
      this.userInfo.nearPasswordChangeAnswer = true;
      sessionStorage.setItem("userInfo", JSON.stringify(this.userInfo));
      this.$router.push({ path: "/philips/profile/UserProfile" });
      this.$parent.close();
    },
    inputAnswerNo: function (event) {
      this.userInfo.nearPasswordChangeAnswer = true;
      sessionStorage.setItem("userInfo", JSON.stringify(this.userInfo));
      this.$parent.close();
    },
  },
  template: `
        <div class="modal-card" style="width: 500px;">
          <header class="modal-card-head">
              <p class="modal-card-title" style="color: whitesmoke;">パスワード変更依頼</p>
          </header>
          <section class="modal-card-body" style="border: 1px solid #dbdbdb;">
            <div>
              <p>パスワードの有効期限がまもなく終了します。<br>
              「ユーザープロファイル」からパスワードの<br>変更をお願いいたします。<br>
              パスワード有効期限：{{passwordLimit}} まで</p>
            </div>
          </section>
          <footer class="modal-card-foot">
            <div>
            <b-button
              class="button is-primary is-inverted has-text-centered"
              type="button"
              v-on:click="inputAnswerYes"
            >
            はい
            </b-button>
            <b-button
              class="button is-light is-inverted has-text-centered"
              v-on:click="inputAnswerNo"
            >いいえ</b-button>
            </div>
          </footer>
        </div>
      `,
};

export default {
  components: { header },
  name: "philipsHome",
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = Number(userInfo.roleId);
    var caveatPasswordChange = false;
    if (
      userInfo.nearPasswordForceChange &&
      !userInfo.nearPasswordChangeAnswer
    ) {
      caveatPasswordChange = true;
    }
    
    return {
      notice: "",
      role: role,
      caveatPasswordChange,
      userInfo,
      extUserStatus:extUserStatus,
      roleId,
      listOfShippingDate: [],
      oneClickOrderUpdateDate: "",
      oneClickOrderUpdateButtonDisabled: false,
      oneClickOrderUpdateButtonLabel: UPDATE_BUTTON_LABEL.DEFAULT,
      listOfKensaTaskData: [],
      listOfCpapTaskData: [],
      taskUpdateDate: "",
      taskUpdateButtonDisabled: false,
      taskUpdateButtonLabel: UPDATE_BUTTON_LABEL.DEFAULT,
      listOfNoticeData: [],
      listOfGuidanceData: [],
      listOfEventData: [],
      listOfNewsData: [],
      listOfProductData: [],
      filterdListOfNoticeData: [],
      filterdListOfGuidanceData: [],
      filterdListOfEventData: [],
      filterdListOfNewsData: [],
      filterdListOfProductData: [],
      noticeModalActive: false,
      modalTitle: "",
      modalContent: "",
      modalCreatedAt: "",
    };
  },
  methods: {
    closeModal: function (event) {
      this.userInfo.nearPasswordChangeAnswer = true;
      sessionStorage.setItem("userInfo", JSON.stringify(this.userInfo));
      this.caveatPasswordChange = false;
    },
    goToArticleList(type) {
      this.$router.push({ path: "/guest/article-list?type=" + type });
    },
    goToExternalLinkUrl(externalLinkUrl) {
      const url = externalLinkUrl;
      window.open(url, "_blank");
    },
    goToTitleLinkUrl(titlelLinkUrl) {
      const url = titlelLinkUrl;
      window.open(url, "_blank");
    },
    showModal(title, content, createdAt) {
      this.modalTitle = title;
      this.modalContent = content;
      this.modalCreatedAt = createdAt;
      this.noticeModalActive = true;
    },
    // ホーム画面　掲載記事取得
    searchHomePortalArticles() {
      const THIS = this;
      return this.apiAnsyncCall(
        function (client) {
          return client.apis.portalHome.searchHomePortalArticles();
        },
        function (success) {
          if (success.obj.portalNoticeList) {
            THIS.listOfNoticeData = success.obj.portalNoticeList;
          } else {
            THIS.listOfNoticeData = 0;
          }
          for (let i = 0; THIS.listOfNoticeData.length > i; i++) {
            THIS.filterdListOfNoticeData.push(THIS.listOfNoticeData[i]);
            if (i == 4) break;
          }
          if (success.obj.portalGuidanceList) {
            THIS.listOfGuidanceData = success.obj.portalGuidanceList;
          } else {
            THIS.listOfGuidanceData = 0;
          }
          for (let i = 0; THIS.listOfGuidanceData.length > i; i++) {
            THIS.filterdListOfGuidanceData.push(THIS.listOfGuidanceData[i]);
            if (i == 4) break;
          }
          if (success.obj.portalEventList) {
            THIS.listOfEventData = success.obj.portalEventList;
          } else {
            THIS.listOfEventData = 0;
          }
          for (let i = 0; THIS.listOfEventData.length > i; i++) {
            if (i == 0) continue;
            THIS.filterdListOfEventData.push(THIS.listOfEventData[i]);
            if (i == 3) break;
          }
          if (success.obj.portalNewsList) {
            THIS.listOfNewsData = success.obj.portalNewsList;
          } else {
            THIS.listOfNewsData = 0;
          }
          for (let i = 0; THIS.listOfNewsData.length > i; i++) {
            if (i == 0) continue;
            THIS.filterdListOfNewsData.push(THIS.listOfNewsData[i]);
            if (i == 3) break;
          }
          if (success.obj.portalProductList) {
            THIS.listOfProductData = success.obj.portalProductList;
          } else {
            THIS.listOfProductData = 0;
          }
          for (let i = 0; THIS.listOfProductData.length > i; i++) {
            THIS.filterdListOfProductData.push(THIS.listOfProductData[i]);
            if (i == 2) break;
          }
        },
        function (error) {
          THIS.showErrorMessage(error);
        }
      );
    },
    downloadFile(fileAddress) {
      this.apiCall(
        function (client) {
          return client.apis.apiCommon.getDownloadFilePOST({
            body: {
              fileId: 0,
              fileName: fileAddress,
            },
          });
        },
        function (result) {
          var downloadUrl = result.obj.downloadUrl;
          const a = document.createElement("a");
          document.body.appendChild(a);
          a.href = downloadUrl;
          let targetFile = fileAddress.toLowerCase();
          if (targetFile.endsWith(".pdf")) {
            a.target = "_blank";
          }
          a.click();
          a.remove();
        },
        function (error) {
          THIS.showErrorMessage(error);
        }
      );
    },
    getTaskList: function(){
      // 営業所権限のみ処理実施
      if(!(this.roleId == this.role.role_salesOffice)){
        return
      }
      // マイタスクの更新ボタン非活性
      this.taskUpdateButtonDisabled = true
      this.taskUpdateButtonLabel = UPDATE_BUTTON_LABEL.LOADING

      var excuteApi = this.getTaskListPOST;
      var successCallBack = this.getTaskListPOSTSuccess;
      var errorCallBack = this.getTaskListPOSTError;
      // Web Api Call
      this.apiAnsyncCall(excuteApi, successCallBack, errorCallBack);
    },
    getTaskListPOST: function(client) {
      return client.apis.apiCommon.getTaskListPOST({
        body:{
          roleId: this.roleId,
          isExternal: false,
          branchOfficeCode: this.userInfo.branchOfficeCode,
          salesStaffCode: this.userInfo.salesStaffCode,
        }
      });
    },
    getTaskListPOSTSuccess: function(result) {
      // 検索結果取得
      this.listOfKensaTaskData = result.obj.listOfKensaTaskData
      this.listOfCpapTaskData = result.obj.listOfCpapTaskData
      this.taskUpdateDate = result.obj.updateDate
      sessionStorage.setItem('taskList', JSON.stringify(result.obj));
      // マイタスクの更新ボタン活性
      this.taskUpdateButtonDisabled = false
      this.taskUpdateButtonLabel = UPDATE_BUTTON_LABEL.DEFAULT
    },
    getTaskListPOSTError: function(result) {
      // マイタスクの更新ボタン活性
      this.taskUpdateButtonDisabled = false
      this.taskUpdateButtonLabel = UPDATE_BUTTON_LABEL.DEFAULT
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getOneClickOrderList: function() {
      if(!(this.roleId == this.role.role_admin || this.roleId == this.role.role_headOffice || this.roleId == this.role.role_salesOffice)){
        return
      }
      // ワンクリックオーダーの更新ボタン非活性
      this.oneClickOrderUpdateButtonDisabled = true
      this.oneClickOrderUpdateButtonLabel = UPDATE_BUTTON_LABEL.LOADING
      var excuteApi = this.getOneClickOrderListPOST;
      var successCallBack = this.getOneClickOrderListPOSTSuccess;
      var errorCallBack = this.getOneClickOrderListPOSTError;
      // Web Api Call
      this.apiAnsyncCall(excuteApi, successCallBack, errorCallBack);
    },
    getOneClickOrderListPOST: function(client) {
      return client.apis.apiCommon.getOneClickOrderListPOST({
        body:{
          isExternal: false,
          role: this.role
        }
      });
    },
    getOneClickOrderListPOSTSuccess: function(result) {
      // ワンクリックオーダーの更新ボタン活性
      this.oneClickOrderUpdateButtonDisabled = false
      this.oneClickOrderUpdateButtonLabel = UPDATE_BUTTON_LABEL.DEFAULT
      // 検索結果取得
      this.listOfShippingDate = result.obj.listOfShippingDate
      this.oneClickOrderUpdateDate = result.obj.updateDate
      sessionStorage.setItem('oneClickOrderList', JSON.stringify(result.obj));
    },
    getOneClickOrderListPOSTError: function(result) {
      // ワンクリックオーダーの更新ボタン活性
      this.oneClickOrderUpdateButtonDisabled = false
      this.oneClickOrderUpdateButtonLabel = UPDATE_BUTTON_LABEL.DEFAULT
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    shippingButtonColor(kind){
      switch(kind){
        case '自宅配送(簡易PSG)':
          return 'easy'
        case '自宅配送(フルPSG)':
          return 'full'
        case '自宅配送(ホルター心電図)':
          return 'holter'
        case 'cpap':
          return 'cpap'
      }
    },
    goToOneClickOrder(kind, model){
      switch(kind){
        case "自宅配送(簡易PSG)":
        case "自宅配送(フルPSG)":
          this.$router.push({ name: 'HSTAgentRequest', params: {agent:true, oneClickModel: model} })
          break
        case "自宅配送(ホルター心電図)":
          this.$router.push({ name: 'HolterAgentRequest', params: {} })
          break
        case "ホルター院内貸出":
          this.$router.push({ name: 'HolterDepositMachineRequest', params: {} })
          break
        case "CPAP":
          this.$router.push({ name: 'CpapRequest', params: {} })
          break
        case "CPAP預託":
          this.$router.push({ name: 'CpapRequest', params: {instrument:true, cpapAgentReqFlg:true} })
          break
      }
    },
    goTask(row) {
      this.$router.push({
        name: row.UserRouterName,
        params: { isTask: true, rowId: row.id }
      })
    },
  },
  components: {
    "caveatPasswordChange-modal": caveatPasswordChangeForm,
  },
  mounted() {
    this.searchHomePortalArticles();
    const sessionTaskList = JSON.parse(sessionStorage.getItem('taskList'))
    if(sessionTaskList !== null){
      this.listOfKensaTaskData = sessionTaskList.listOfKensaTaskData
      this.listOfCpapTaskData = sessionTaskList.listOfCpapTaskData
      this.taskUpdateDate = sessionTaskList.updateDate
    }
    const sessionOneClickOrderList = JSON.parse(sessionStorage.getItem('oneClickOrderList'))
    if(sessionOneClickOrderList !== null){
      this.listOfShippingDate = sessionOneClickOrderList.listOfShippingDate
      this.oneClickOrderUpdateDate = sessionOneClickOrderList.updateDate
    } else {
      this.getOneClickOrderList();
    }
  },
};
</script>
<style lang="scss" scoped>
.heading-title{
  width:99%;
  height: 50px;
  color:white;
  text-align:left;
  background-color: #061e57;
  border-radius: 10px;
  margin-bottom:10px;
  margin-top:10px;
  padding-left: 20px;
  font-size: 24px;
}
.update-date{
  font-size: 15px;
}
.update-button{
  width:100px;
  margin-right: 15px;
  border-color: white;
  color: white;
  background-color: #061e57;
}
.update-button:disabled { 
  background-color: #a7b4d1 !important;
  border-color: #a7b4d1 !important;
  color: white !important;
  cursor: not-allowed;
}
.notice {
  font-size: 25px;
}
.noticeTextArea {
  width: 100%;
  height: 250px;
}
.content-title {
  font-size: 25px;
  text-align: left;
}
.view-all {
  color: #1c29e6;
  font-size: 15px;
}
.a-left {
  text-align: left;
  margin: 5px 0 5px 0;
  text-align: left;
}
.flex-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  height: auto;
  z-index: 1;
}
.flex-item:nth-child(odd) {
  background-color: #d8eaff;
  margin: 0 10px 10px 0;
  padding: 5px;
  width: 49%;
  height: auto;
}
.flex-item:nth-child(even) {
  background-color: #d8eaff;
  margin: 0 0 10px 0;
  padding: 5px;
  width: 49%;
  height: auto;
}
.flex-item:last-child {
  background-color: #d8eaff;
  margin: 0 0 10px 0;
  padding: 5px;
  width: 49%;
  height: auto;
}
.info-icon {
  width: 24px;
}
/* PDFアイコンセンタリング*/
.table-wrapper > table > tbody > tr > td {
  vertical-align: middle;
}
.event-news-hero-img {
  object-fit: contain;
  height: 120px;
}
.event-news-container {
  display: grid;
  grid-template-columns: 30% 68%;
  grid-template-rows: auto;
  gap: 0px 0px;
  grid-auto-flow: row;
  grid-template-areas: "event-news-item1 news-item2-4";
}
.event-news-item1 {
  grid-area: event-news-item1;
  margin: 0 5px 0 0;
  background-color: #fff;
}
.news-item2-4 {
  grid-area: news-item2-4;
  height: auto;
}
/* ラベル名フォントサイズ */
.table-wrapper > table > thead {
  font-size: 12px;
  vertical-align: middle;
}
.table-wrapper > table > thead > tr > th > div {
  font-size: 12px;
  vertical-align: middle;
}
/* タイトル以外フォントサイズ */
.table-wrapper > table > tbody > tr > td > span {
  font-size: 12px;
  vertical-align: middle;
}
/* 掲載記事タイトルフォントサイズ */
.table-wrapper > table > tbody > tr > td > span > a {
  padding: auto;
  vertical-align: middle;
  font-size: 16px;
}
.table-wrapper > table > tbody > tr > td {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.lab-img {
  text-align: center;
  vertical-align: middle;
  height: auto;
}
.terms-of-use-area {
  width: 100%;
}
.terms-of-use {
  margin: auto;
  height: 50px;
  width: 100%;
  color: blue;
  padding: 20px;
  font-size: 18px;
}
.caveat {
  width: 100%;
  font-size: 15px;
  margin-bottom: 50px;
}
.content {
  background-color: #fff;
  margin: auto;
  padding: 36px;
}
.modal-headline {
  font-size: 36px;
  text-align: left;
  margin: 20px 0 20px 0;
}
.modal-title {
  font-size: 24px;
  text-align: left;
  margin: 0 0 2px 0;
}
.modal-content {
  font-size: 18px;
  text-align: left;
  margin: 0 0 50px 0;
}
.modal-createdAt {
  font-size: 16px;
  text-align: left;
  margin: 0 0 10px 0;
}
.shippingdate-header-notice{
  display:flex;
  align-items:flex-end;
  font-size: 15px;
  margin-left: 10px;
}
.shippingdate-container {
  background-color: #d8eaff;
  display: flex;
  align-items: center;
  gap: 10px; /* 余白 */
  width: 99%;
  height: 140px;
  padding-left: 5px;
  padding-right: 5px;
}
.shippingdate-button {
  width: calc((100% - 70px) / 8); /* 4列にするための計算 */
  height: 130px;
  padding: 0;
  flex-direction: column;
  border: none;
  border-radius: 15px;
  color: white;
  font-size: 14px;
  cursor: pointer;
}
.full {
  background-color: #004EAA;
}
.easy {
  background-color: #6EADF3;
}
.holter {
  background-color: #269A91;
}
.cpap {
  background-color: #002C77;
}
.shippingdate-button-label{
  width: 100%;
}
.model-kind {
  width: auto;
  height: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  text-align: center;
  white-space: normal;
  font-size: clamp(10px, 0.9vw, 16px);
  margin-top: 2px;
  margin-bottom: 10px;
}
.model-title {
  height: 50px;
  font-size: clamp(11px, 1vw, 18px);
  display: flex;
  justify-content: center; /* 横方向の中央 */
  align-items: center;     /* 縦方向の中央 */
  text-align: center;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
}
.shippingdate {
  height: 37px;
  font-size: clamp(12px, 1.3vw, 26px);
  text-align: center;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
}
.task-container {
  display: flex;
  justify-content: space-between;
  position: relative;
  align-items: center; /* 更新ボタンを縦方向中央に */
}
.right-block {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.update-btn {
  height: 100%; /* 左側2行の高さに合わせて縦に伸ばす */
  display: flex;
  align-items: center;
  width:70px
}
.link-container {
  display: flex;
  flex-wrap: wrap; /* 折り返し */
  gap: 10px; /* 余白 */
  width: 800px; /* 任意 */
  margin: 0 auto;
}
.link-button {
  border-radius: 15px;
  width: calc((100% - 20px) / 3); /* 3列にするための計算 */
  height: 225px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  color: white;
  font-size: 14px;
}
</style>
<style>
#philipsHome .b-table .table {
  table-layout: fixed;
}
/* kensaTask-table */
#philipsHome .kensaTask-table .table > thead > tr > th:nth-child(1) {
  width: 70%;
}
#philipsHome .kensaTask-table .table > thead > tr > th:nth-child(2) {
  width: 10%;
}
#philipsHome .kensaTask-table .table > thead > tr > th:nth-child(3) {
  width: 10%;
}
#philipsHome .kensaTask-table .table > thead > tr > th:nth-child(4) {
  width: 10%;
}
/* task-table */
#philipsHome .otherTask-table .table > thead > tr > th:nth-child(1) {
  width: 30%;
}
#philipsHome .otherTask-table .table > thead > tr > th:nth-child(2) {
  width: 60%;
}
#philipsHome .otherTask-table .table > thead > tr > th:nth-child(3) {
  width: 10%;
}
#philipsHome .otherTask-table .table > tbody > tr {
  cursor: pointer;
}
/* notice-table */
#philipsHome .notice-table .table > thead > tr > th:nth-child(1) {
  width: 60%;
}
/* guidance-table */
#philipsHome .guidance-table .table > thead > tr > th:nth-child(1) {
  width: 70%;
}
#philipsHome .guidance-table .table > thead > tr > th:nth-child(2) {
  width: 22%;
}
#philipsHome .guidance-table .table > thead > tr > th:nth-child(3) {
  width: 8%;
}
/* event-table */
#philipsHome .event-table .table > thead > tr > th:nth-child(1) {
  width: 70%;
}
#philipsHome .event-table .table > thead > tr > th:nth-child(2) {
  width: 15%;
}
#philipsHome .event-table .table > thead > tr > th:nth-child(3) {
  width: 15%;
}
/* product-table */
#philipsHome .product-table .table > thead > tr > th:nth-child(1) {
  width: 47%;
}
#philipsHome .product-table .table > thead > tr > th:nth-child(2) {
  width: 23%;
}
#philipsHome .product-table .table > thead > tr > th:nth-child(3) {
  width: 12%;
}
#philipsHome .product-table .table > thead > tr > th:nth-child(4) {
  width: 8%;
}
#philipsHome .product-table .table > thead > tr > th:nth-child(5) {
  width: 10%;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/home.vue